/**
 * Base URL for ticket admin/API calls.
 * Local Square testing uses HTTPS CRA + HTTP API; browsers block that as mixed content.
 * In that case return '' so requests go same-origin through setupProxy.js.
 */
const CONFIGURED_API_BASE = process.env.REACT_APP_API_URL ?? '';

export const getTicketApiBase = () => {
  if (
    typeof window !== 'undefined'
    && window.location.protocol === 'https:'
    && /^http:\/\//i.test(CONFIGURED_API_BASE)
  ) {
    return '';
  }
  return CONFIGURED_API_BASE;
};

export default getTicketApiBase;
